'use client';

import { Checkbox } from '@/components/ui/checkbox';
import type { TFunction } from 'i18next';
import type { Table } from '@tanstack/react-table';
import type { CompanySearchResult } from '@/lib/actions/company-search';

interface SelectAllCheckboxProps {
  t: TFunction<'translation', undefined>;
  table: Table<CompanySearchResult>;
}

export function SelectAllCheckbox({
  t,
  table,
}: SelectAllCheckboxProps) {
  return (
<Checkbox
            aria-label={t('search.selectAllOnPage', 'Select all on this page')}
            checked={
              table.getIsAllPageRowsSelected()
                ? true
                : table.getIsSomePageRowsSelected()
                  ? 'indeterminate'
                  : false
            }
            onCheckedChange={(value) =>
              table.toggleAllPageRowsSelected(value === true)
            }
          />
  );
}
